/*
    Add here your own custom javascript
*/

// Fix for the RTL language in the demo
document.querySelectorAll('[href="/ar"]').forEach(link => {
    link.setAttribute('target', '_blank')
})

document.addEventListener('DOMContentLoaded', function() {
    // Start Schema Reviews & aggregateRating
    if (typeof _appioGoogleReviewsData !== 'undefined' && _appioGoogleReviewsData.reviews) {
        // Map reviews into schema.org format
        const reviews = _appioGoogleReviewsData.reviews.map(review => ({
            "@type": "Review",
            "author": {
                "@type": "Person",
                "name": review.authorName
            },
            "datePublished": review.createdAt.split(' ')[0],
            "reviewBody": review.originalText || "",
            "reviewRating": {
                "@type": "Rating",
                "ratingValue": review.rating,
                "bestRating": 5,
                "worstRating": 1
            },
            "url": review.reviewUrl
        }));

        // Aggregate rating
        const aggregateRating = {
            "@type": "AggregateRating",
            "ratingValue": _appioGoogleReviewsData.place.ratings,
            "reviewCount": _appioGoogleReviewsData.place.total
        };

        // Get your existing schema
        const schemaEl = document.getElementById('localbusiness-schema');
        if (schemaEl) {
            let schemaData = JSON.parse(schemaEl.textContent);

            // Inject reviews + rating
            schemaData.aggregateRating = aggregateRating;
            schemaData.review = reviews;

            // Update schema in DOM
            schemaEl.textContent = JSON.stringify(schemaData);
        }
    }
    // End Schema Reviews & aggregateRating

    var intervalId = setInterval(function() {
      var h1 = document.querySelector("#reviews h1");
      if (h1) {
        var h2 = document.createElement("h2");
        h2.innerHTML = h1.innerHTML;
        h2.className = h1.className + " h1";
        h1.parentNode.replaceChild(h2, h1);
        clearInterval(intervalId);
      }
    }, 300);


const targetNode = document.getElementById('sticky-atc');

const config = { attributes: true, attributeFilter: ['class'] };

const callback = function(mutationsList, observer) {
  for(const mutation of mutationsList) {
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
   if (targetNode.classList.contains('show')) {
        document.getElementById('ShopifyChat').style.bottom = '80px';
        document.getElementById('smile-ui-lite-launcher-frame-container').style.bottom = '90px';
      }
      else{
        document.getElementById('ShopifyChat').style.bottom = '16px';
        document.getElementById('smile-ui-lite-launcher-frame-container').style.bottom = '25px';
      }
    }
   }
};

const observer = new MutationObserver(callback);

observer.observe(targetNode, config);

});


// EcomGraduates - Affiliate tracking code
function addRefParamToUrlsAndSetCookie () {
    const urlParams = new URLSearchParams(window.location.search)
    let refParam = urlParams.get('ref')

    if (!refParam) {
        // Check if the "ref" cookie exists
        const cookies = document.cookie.split(';')
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim()
            if (cookie.startsWith('ref=')) {
                refParam = cookie.substring(4)

                urlParams.set('ref', refParam)
                break
            }
        }
    }

    if (refParam) {
    // Set the "ref" cookie with the "ref" parameter value
        document.cookie = `ref=${refParam}; expires=${new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)}; path=/`

        // Update the URLs on the page with the "ref" parameter value
        const links = document.getElementsByTagName('a')
        for (let i = 0; i < links.length; i++) {
            const link = links[i]
            const url = new URL(link.href)
            if (url.hostname === 'ecomgraduates.com') {
                if (url.search) {
                    url.search += `&ref=${refParam}`
                } else {
                    url.search = `?ref=${refParam}`
                }
                link.href = url.href
            }
        }
    }
}
// addRefParamToUrlsAndSetCookie()


// Header Top Bar Sticky JS
window.addEventListener("scroll", function () {
  const menu = document.getElementById("dtf-topbar");
  const header = document.getElementById("mobile-menu");

  if (window.scrollY > 150) {
    menu.classList.add("topbar-sticky");
    header.classList.add("topbar-sticky");
  } else {
    menu.classList.remove("topbar-sticky");
    header.classList.remove("topbar-sticky");
  }
});

